import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { CALENDAR_LOCALES } from '../../../assets/i18n/calendar_locale';
import moment from 'moment';
import { FormGroup, UntypedFormControl } from '@angular/forms';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import * as _ from 'lodash';

@Component({
  selector: 'mapfre-auditlib-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CalendarComponent implements OnInit {

  @Input() events;
  @Input() selectionMode;
  @Input() inline;
  @Output() onSelect = new EventEmitter();

  _form: UntypedFormControl;
  @Input()
  set form(f) {
    this._form = f;
    this._form.valueChanges.subscribe(res => {
      if (res) {
        if (_.isArray(res)) {
          _.forEach(res, (r: any) => {
            if (r) {
              r.setHours("12");
            }
          });
        } else {
          if (moment(res).isValid()) {
            res.setHours("12");
          }
        }
        this._form.setValue(res, { emitEvent: false });
      }
    });
  };
  get form() {
    return this._form;
  }

  @Input() minDate;
  @Input() maxDate;
  @Input() readonly: Boolean;
  @Input() appendTo;
  @Input() showButtonBar = false;
  @Output() onClearClick = new EventEmitter();
  format: string = 'dd/mm/yy';


  constructor(public translateService: TranslateService) {
    this.events = [];
    this.selectionMode = '';
    this.form = new UntypedFormControl(null, []);
    this.inline = true;

  }


  ngOnInit() {
    if (this.translateService.currentLang.toUpperCase() == 'EN') {
      this.format = 'mm/dd/yy'
    }
    this.isDisabled();
  }

  matchDate(date) {
    let severity = [];
    this.events.forEach(element => {
      const dateEvent = moment(element.date).format('DD/MM/YYYY');
      const dateCalendar = moment(date).format('DD/MM/YYYY');
      if (dateEvent === dateCalendar) {
        severity.push(element.severity);
      }
    });

    return severity
  }

  select(event) {
    this.onSelect.emit(event);
  }

  clearClick(event) {
    this.onClearClick.emit(event);
  }

  isDisabled() {
    if (this.readonly) {
      this.form.disable();
    }
  }

}
